module.exports = __webpack_public_path__ + "7a413a237ab08365c18274165fa59b31.png";